module.exports = __webpack_public_path__ + "img/m-consensuslab.d2bd6228.png";